import {
  Button,
  theme,
  TextArea,
  Input,
  Select,
} from '~components/web-components'
import styled from 'styled-components'

const { SPACINGS, BREAKPOINTS } = theme

export const StyledInput = styled(Input)`
  width: 300px;

  @media only screen and (${BREAKPOINTS.sm}) {
    width: 344px;
  }
`

export const StyledSelect = styled(Select)`
  width: 300px;

  > div {
    padding: 0;
  }

  .MuiOutlinedInput-input {
    padding: 7.5px 14px;
  }

  @media only screen and (${BREAKPOINTS.sm}) {
    width: 344px;
  }
`

export const StyledTextArea = styled(TextArea)`
  width: 300px;

  @media only screen and (${BREAKPOINTS.sm}) {
    width: 344px;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${SPACINGS[4]};
  row-gap: ${SPACINGS[1]};
  margin-top: ${SPACINGS[5]};
  flex-direction: column-reverse;
  align-items: center;

  button {
    min-width: fit-content;
  }

  @media only screen and (${BREAKPOINTS.sm}) {
    justify-content: flex-end;
    flex-direction: row;
  }
`

export const PrimaryButton = styled(Button)`
  width: 200px;
`
